var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsMobileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Setting Fill",
    clipPath: "url(#clip0_696_8571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.9459 13.9076L21.9475 13.0857C21.2636 12.5227 21.2648 11.4762 21.9475 10.9143L22.9459 10.0924C23.6564 9.50747 23.8382 8.50444 23.378 7.70733L21.4066 4.29267C20.9463 3.49561 19.9866 3.15155 19.125 3.47433L17.914 3.92803C17.0845 4.23872 16.1788 3.7147 16.0335 2.84236L15.8209 1.5667C15.6696 0.658922 14.8918 0 13.9714 0H10.0285C9.10816 0 8.33031 0.658922 8.17905 1.56675L7.96642 2.84236C7.82078 3.71625 6.91394 4.2382 6.08599 3.92808L4.87497 3.47433C4.01327 3.15155 3.05364 3.49566 2.59338 4.29267L0.621955 7.70728C0.161783 8.5043 0.343471 9.50737 1.05405 10.0924L2.05244 10.9143C2.73644 11.4773 2.73508 12.5237 2.05244 13.0856L1.054 13.9075C0.343471 14.4925 0.161736 15.4956 0.621908 16.2926L2.59338 19.7073C3.0536 20.5043 4.01303 20.8484 4.87497 20.5256L6.08594 20.0719C6.91558 19.7611 7.82102 20.2855 7.96638 21.1576L8.179 22.4332C8.33031 23.3411 9.10816 24 10.0285 24H13.9714C14.8917 24 15.6696 23.3411 15.8208 22.4333L16.0334 21.1577C16.179 20.284 17.0858 19.7617 17.9139 20.072L19.125 20.5257C19.9869 20.8485 20.9463 20.5044 21.4066 19.7073L23.3781 16.2926C23.8382 15.4956 23.6564 14.4925 22.9459 13.9076ZM12 14.75C10.4836 14.75 9.24996 13.5164 9.24996 12C9.24996 10.4836 10.4836 9.24998 12 9.24998C13.5163 9.24998 14.75 10.4836 14.75 12C14.75 13.5164 13.5163 14.75 12 14.75Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 16C9.7944 16 8 14.2056 8 12C8 9.7944 9.7944 8 12 8C14.2056 8 16 9.7944 16 12C16 14.2056 14.2056 16 12 16Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_696_8571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsMobileIcon);
export default __webpack_public_path__ + "static/media/settings-mobile-icon.af3258b56d70131a52a8573766746356.svg";
export { ForwardRef as ReactComponent };